module.exports = __webpack_public_path__ + "img/medalha-acesso-a-justica_old.4b77bb21.jpeg";